import React from 'react';

function SectionHeader(props) {
  	const { title, children } = props;
		
  
  	return (
		<div className="flex justify-between items-center mb-4">
			<h4 className="w-full text-xl font-semibold dark:text-white">
				{title}
			</h4>
			{children}
		</div>
  	);
}

export default SectionHeader;